import { Component, Input, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormGroup, ReactiveFormsModule, AbstractControl } from '@angular/forms';

import '@maersk-global/mds-components-core/mc-textarea';

@Component({
  selector: 'app-create-parts-remarks',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './create-part-remarks.component.html',
  styleUrls: ['./create-part-remarks.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CreatePartsRemarksComponent {
  @Input() formGroup!: FormGroup;

  isControlInErrorState(control: AbstractControl | null | undefined): boolean | null {
    return control?.invalid && control.touched ? true : null;
  }
}
